
import QuestionTitle from '@/components/Question/QuestionTitle.vue';
import QuestionOptionInput from '@/components/Question/options/QuestionOptionInput.vue';
import QuestionDateInput from '@/components/Question/options/QuestionDateInput.vue';
// import TheGradient from '@/components/TheGradient.vue';
import RadioButton from '@/components/RadioButton.vue';
import SelectInput from '@/components/SelectInput.vue';
import { IQuestion } from '@/types/question';
import {
  ComponentPublicInstance,
  computed, defineComponent,
  PropType, ref
} from 'vue';
import {useStore} from "vuex";
import {key} from "@/store";
import OptionDropDown from "@/components/OptionDropDown/OptionDropDown.vue";
import OptionDropDownRow from "@/components/OptionDropDown/OptionDropDownRow.vue";
import { apiDownloadQuestionFile, apiUploadQuestionFile, apiRemoveQuestionFile, updateQuestionCategoryApi } from '@/api/QuestionApi';
import SearchDropDown from '@/components/SearchDropDown.vue';
import SearchMultipleSelect from '@/components/SearchMultipleSelect.vue';
import FileUpload from '@/components/Question/QuestionAnswer/FileUpload.vue';
import { notification } from 'ant-design-vue';

export default defineComponent({
  name: 'QuestionAnswer',
  components: {
    FileUpload,
    SearchMultipleSelect,
    QuestionTitle,
    // TheGradient,
    QuestionOptionInput,
    RadioButton,
    SelectInput,
    OptionDropDown,
    OptionDropDownRow,
    SearchDropDown,
    QuestionDateInput,
  },
  props: {
    question: {
      type: Object as PropType<IQuestion>,
      required: true,
    },
    ix: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    error :{
      type: String,
      required: true,
    },
  },
  emits: ['handleClick', 'handleValueUpdate', 'removeQuestion', 'handleAddQuestion', 'updateQuestionCategory'],
  setup(props, ctx) {
    const store = useStore(key)
    const currentCategory = computed(() => store.state.currentCategory);
    const allCategories = computed(() => store.state.categories);
    const isCategoryDropDownOpen = ref(false);
    const handleClick = (questionId: number) => ctx.emit('handleClick', questionId);
    const handleValueUpdate = (val: string | Array<string>) =>
      ctx.emit('handleValueUpdate', props.question.id, val);

    const handleYesNoChange = (answerValueId: string) => {
      handleValueUpdate([answerValueId]);
    };

    const arrayIncludeOrOmit = (array: Array<string>, value: string): Array<string> => {
      const ix = array.indexOf(value);
      if (ix !== -1) {
        array.splice(ix, 1);
      } else {
        array.push(value);
      }
      return array;
    };

    const handleMultipleChange = (answerValueId: string) => {
      let res: Array<string> = [];
      if (props.question.user_answer === null || typeof props.question.user_answer === 'string') {
        res = arrayIncludeOrOmit(res, answerValueId);
      } else {
        res = arrayIncludeOrOmit(props.question.user_answer, answerValueId);
      }
      handleValueUpdate(res);
    };

    const handleSelectChange = (answerValueId: string) => {
      console.log(answerValueId)
      handleValueUpdate([answerValueId]);
    };

    const handleSearchSelectChange = (v: {id: string, name: string}) => {
      console.log({
        x: v,
      })
      handleValueUpdate([v.id]);
    }
    const isResponseSelected = (answerValueId: string) => {
      if (typeof props.question.user_answer === 'string' || props.question.user_answer === null) {
        return false;
      }
      return props.question.user_answer.includes(answerValueId);
    };

    type IgetSelectInputOptionsReturn = Array<{ label: string, value: string}>;
    const getSelectInputOptions = (
      answerValues: Record<string, string>,
    ): IgetSelectInputOptionsReturn => {
      const response: IgetSelectInputOptionsReturn = [];
      Object.keys(answerValues).forEach((key) => {
        response.push({
          label: answerValues[key], value: key,
        });
      });
      return response;
    };
    const getSearchSelectInputOptions = (
      answerValues: Record<string, string>,
    ): Array<{ name: string, id: string}> => {
      const response: Array<{ name: string, id: string}> = [];
      Object.keys(answerValues).forEach((key) => {
        response.push({
          name: answerValues[key], id: key,
        });
      });
      return response;
    };
    const setEditMode = () => {
      store.commit('setQuestionEditMode', true);
      ctx.emit('handleClick', props.question.id);
    }

    const openCategoryDropDown = () => {
      isCategoryDropDownOpen.value = true;
    }
    const closeCategoryDropDown = () => {
      isCategoryDropDownOpen.value = false;
    }

    const moveQuestionToCategory = async (categoryId: number) => {
      if(!props.question.quiz_id) return null;
      const res = await updateQuestionCategoryApi({
        categoryId,
        questionId: props.question.id,
        quizId: props.question.quiz_id,
      });
      closeCategoryDropDown();
      ctx.emit('updateQuestionCategory', props.question.id, categoryId);
    }

    const handleAddQuestion = () => {
      store.commit('setQuestionEditMode', true);
      ctx.emit('handleAddQuestion', props.ix, props.question.position + 1)
    }

    const handleFileUpload = async (files: File[],resolve: (v?: any) => void,
                                    reject: (r?: any) => void) => {
      if (!files.length) return

      handleValueUpdate(files[0].name)

      try {
        await apiUploadQuestionFile({
          id: props.question.id,
          file: files[0],
        })

        resolve();
      } catch (error) {
        reject(error);
      }
    }

    const handleFileDownload = async () => {
      try {
        const res = await apiDownloadQuestionFile(props.question.id)
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([res.data]));
        link.download = props.question.user_answer as string || ''
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
      }
    }

    const handleFileRemove = async () => {
      try {
        await apiRemoveQuestionFile(props.question.id);
        handleValueUpdate('');
        notification.success({
          message: 'File removed',
          description: 'The file has been removed successfully.',
          duration: 4,
        });
      } catch (error) {
        console.log(error);
      }
    }

    return {
      handleClick,
      handleValueUpdate,
      handleYesNoChange,
      isResponseSelected,
      handleMultipleChange,
      getSelectInputOptions,
      handleSelectChange,
      currentCategory,
      setEditMode,
      allCategories,
      isCategoryDropDownOpen,
      openCategoryDropDown,
      closeCategoryDropDown,
      moveQuestionToCategory,
      getSearchSelectInputOptions,
      handleSearchSelectChange,
      handleAddQuestion,
      handleFileUpload,
      handleFileDownload,
      handleFileRemove,
    };
  },
});
